import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CentrifugoService, GameBaseApi, HockeyGameApi, HockeyGameLog } from '@mtgame/core';
import { map } from 'rxjs/operators';
import { GameTimelineService, STORE_LOGS_KEY } from '@core/services/game-timeline.service';
import { GameRootService } from '@core/services/game-root.service';

@Injectable()
export class HockeyGameTimelineService extends GameTimelineService {
  get logs$(): Observable<HockeyGameLog[]> {
    return this.store.get(STORE_LOGS_KEY).pipe(
      map(logs => logs.sort((a, b) => a.compare(b)))
    );
  }

  constructor(
    protected gameRootService: GameRootService,
    private hockeyGameApi: HockeyGameApi,
    protected centrifugoService: CentrifugoService,
    protected gameBaseApi: GameBaseApi,
  ) {
    super(gameRootService, centrifugoService, gameBaseApi);
  }

  async getLogs(): Promise<HockeyGameLog[]> {
    const logs = await this.hockeyGameApi.getLogs(this.gameId);
    this.store.save(STORE_LOGS_KEY, logs);
    return logs;
  }

  protected onGameLogAdded(data: any): void {
    this.store.prependItem(STORE_LOGS_KEY, HockeyGameLog.toFront(data));
  }

  protected onGameLogUpdated(data: any): void {
    this.store.updateItem(STORE_LOGS_KEY, HockeyGameLog.toFront(data));
  }
}
